<template>
    <div class="main-page">
        <!-- 轮播 -->
        <div class="main-slide">
          <VantSlide
            :videoObj="videoObj"
            :albumArr="albumArr"
            ref="vantSlide"
            @topSwipe="topSwipe"
            @topPlay="topPlay"
          />
          <VantInfo
            :goodsInfo="goodsInfo"
          />
          <div style="border-top: 12px solid #F2F3F5;">
            <StoreInfo
              :storeInfo="storeInfo"
            />
          </div>
          <div style="border-top: 12px solid #F2F3F5;">
            <GoodsInfo
              :title="title"
              :detailsInfo="detailsInfo"
              ref="goodsInfo"
              @infoPause="infoPause"
              @infoPlay="infoPlay"
              v-if="detailsInfo.id"
            />
            <BaseInfo 
              :baseInfo="baseInfo"
              @detailPlay="detailPlay"
              ref="baseInfos"
              v-if="baseInfo.length"
            />
          </div>
          
          <VantBtns/>
        </div>
    </div>
</template>

<script>
import { setTitle } from "../../utils/setTitle.js"
import VantSlide from './components/vant-slide'
import VantInfo from './components/vant-info'
import StoreInfo from './components/store-info'
import GoodsInfo from './components/goods-info'
import VantBtns from './components/vant-btns'
import BaseInfo from  './components/base-Info.vue'
import { getCurrentInstance } from 'vue';
import { getUrlKey } from '../../utils/util.js'
import { getAppToken } from "../../utils/getAppToken";
export default {
  name: 'preview',
  components:{
    VantSlide,
    VantInfo,
    StoreInfo,
    GoodsInfo,
    VantBtns,
    BaseInfo
  },
  data() {
    return {
      videoObj: {},
      albumArr: [],
      goodsInfo: {},
      storeInfo: {},
      title: '商品详情',
      detailsInfo: {
        video: {
          url: '',
          id: 0,
        },
        detailsImg: ''
      },
      details: {},
      baseInfo: [],
      token: ''
    }
  },
  created() {
    let id = getUrlKey('id')
    let previewStoreId = getUrlKey('previewStoreId')
    if(!id && !previewStoreId) {
      return
    }
    this.getInfo(id, previewStoreId)
  },
  methods: {
    getInfo(id, previewStoreId) {
        // const { proxy } = getCurrentInstance();
        this.$toast.loading({
          message: "加载中",
          duration: 1500,
        });
        this.$http.get('/h5/goods/detail?id=' + id + '&previewStoreId=' + previewStoreId).then(({ data: res }) => {
          if(1 == res.code) {
            let info = res.data
            this.storeInfo = info.store
            this.goodsInfo = {
                title: info.detail.title,
                price: info.detail.price_zone,
                share: info.detail.sale_count,
                inventory: -1 == info.detail.stock ? '不限' : info.detail.stock
            }
            this.albumArr = info.detail.images
            this.baseInfo = info.detail.details
            if(info.detail.video_id) {
              this.videoObj = info.detail.video
            }
            if(info.detail.bring_video_id) {
              this.detailsInfo = info.detail.bring_video
            }
          } else {
            // this.$toast.error({
            //   message: "服务器异常",
            //   duration: 1500,
            // });
          }
        })
    },
    topPlay() {
      if(this.$refs.goodsInfo) {
        this.$refs.goodsInfo.isPlay = false
      }
      this.$refs.baseInfos.detailObj[this.$refs.baseInfos.playIndex].isPlay = false
    },
    infoPlay() {
      if(this.$refs.vantSlide) {
        this.$refs.vantSlide.isPlay = false
      }
      this.$refs.baseInfos.detailObj[this.$refs.baseInfos.playIndex].isPlay = false
    },
    detailPlay() {
      if(this.$refs.goodsInfo) {
        this.$refs.goodsInfo.isPlay = false
      }
      if(this.$refs.vantSlide) {
        this.$refs.vantSlide.isPlay = false
      }
    }
  },
}
</script>

<style scoped>
  .main-page {
    background: #fff;
    padding-bottom: 58px;
  }
  .main-slide {
    border-bottom: 12px solid #F2F3F5;
  }
</style>
